import { onListViewSelectionChangeComplete } from 'owa-mail-actions/lib/onListViewSelectionChangeComplete';
import { orchestrator } from 'satcheljs';
import { default as activateTab } from '../actions/activateTab';
import { primaryTab } from '../store/tabStore';

orchestrator(onListViewSelectionChangeComplete, () => {
    // Whenever selection changes in the listView we have activate primary reading pane
    // to reflect the selection
    activateTab(primaryTab);
});
